export const TOGGLE_MAIN_MENU = 'TOGGLE_MAIN_MENU';
export const SET_CURRENT_MENU_LEVEL = 'SET_CURRENT_MENU_LEVEL';
export const SET_ACTIVE_MENU_SECTION = 'SET_ACTIVE_MENU_SECTION';
export const TOGGLE_CART_NOTIFICATION = 'TOGGLE_CART_NOTIFICATION';
export const SET_CART_TOTAL_QUANTITY = 'SET_CART_TOTAL_QUANTITY';
